/**
 * Runs `callback` when the main thread is idle, at the latest 2 s later (the timeout Chrome's
 * docs use). Without `requestIdleCallback` (Safari) it runs right after `load`, like Next.js'
 * `lazyOnload`.
 */
export const runWhenIdle = (callback: () => void): void => {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => callback(), { timeout: 2000 });
    return;
  }
  if (document.readyState === 'complete') {
    setTimeout(callback, 1);
  } else {
    window.addEventListener('load', () => setTimeout(callback, 1), { once: true });
  }
};
